import { SPACES_REQUIRED_SUPPORTED_SERVICES } from '@rover/constants/src/search/searchPage.constants';
import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';

/**
 * @description sets spaces_required if serviceType is valid
 * @param searchParams
 * @param spacesRequired
 * @param serviceType
 */
export const setSpacesRequired = (
  searchParams: URLSearchParams,
  spacesRequired?: number,
  serviceType?: ServiceTypeSlug
): void => {
  const includeSpacesRequired =
    spacesRequired &&
    serviceType &&
    SPACES_REQUIRED_SUPPORTED_SERVICES.has(serviceType as ServiceTypeSlug);
  if (includeSpacesRequired) {
    searchParams.set(searchFilterKeysMap.spacesRequired, spacesRequired.toString());
  }
};
